module.exports = __webpack_public_path__ + "static/media/clock.13e73f5d.svg";